import {
  BarChart3,
  Percent,
  PieChart,
  RefreshCcw,
  Target,
  TrendingDown,
  TrendingUp,
  Wallet,
} from "lucide-react";
import DashboardCard from "../../../components/ui/dashboard/DashboardCard";
import { formatCurrency } from "../../../lib/utils";
import { Vehicle } from "../../vehicle/@types";

interface VehicleFinanceCardProps {
  vehicle: Vehicle;
}

const VehicleFinanceCard02: React.FC<VehicleFinanceCardProps> = ({
  vehicle,
}) => {
  const cards = [
    // ===== GLOBAL FINANCIALS =====
    {
      label: "Landing Cost",
      value: formatCurrency(vehicle.landingCost),
      icon: <Wallet className="h-8 w-8 text-primary" />,
    },
    {
      label: "Journey Balance",
      value: formatCurrency(vehicle.journeyBalance),
      icon: <BarChart3 className="h-8 w-8 text-indigo-500" />,
    },
    {
      label: "Recovery Progress",
      value: `${Number(vehicle.progressPercentageAgainstLandingCost.toFixed(2).replace(/\.00$/, ""))}%`,
      icon: <Percent className="h-8 w-8 text-teal-500" />,
    },
    {
      label: "Target Remaining",
      value: formatCurrency(vehicle.targetRemaining),
      icon: <Target className="h-8 w-8 text-yellow-500" />,
    },
    {
      label: "Total Income",
      value: formatCurrency(vehicle.totalIncome),
      icon: <TrendingUp className="h-8 w-8 text-green-500" />,
    },
    {
      label: "Total Expenses",
      value: formatCurrency(vehicle.totalExpenses),
      icon: <TrendingDown className="h-8 w-8 text-red-500" />,
    },
    {
      label: "Total Distance",
      value: `${vehicle.totalDistance.toLocaleString()} km`,
      icon: <BarChart3 className="h-8 w-8 text-blue-500" />,
    },
    {
      label: "Total Trips",
      value: vehicle.totalTrips,
      icon: <PieChart className="h-8 w-8 text-orange-500" />,
    },
    {
      label: "Replacement Status",
      value: vehicle.replacementStatus,
      icon: <RefreshCcw className="h-8 w-8 text-purple-500" />,
    },
    {
      label: "Global Performance",
      value: vehicle.financialPerformance,
      icon: <BarChart3 className="h-8 w-8 text-indigo-600" />,
    },

    // ===== ACTIVE SESSION =====
    {
      label: "Current balance",
      value: formatCurrency(vehicle.currentAssignmentJourneyBalance),
      icon: <Wallet className="h-8 w-8 text-primary" />,
    },
    {
      label: "Current Performance",
      value: vehicle.currentAssignmentFinancialPerformance,
      icon: <BarChart3 className="h-8 w-8 text-green-600" />,
    },
    {
      label: "Current Progress",
      value: `${Number(vehicle.currentAssignmentProgressAgainstLandingCost).toFixed(2).replace(/\.00$/, "")}%`,
      icon: <Percent className="h-8 w-8 text-teal-600" />,
    },
    {
      label: "Current Target Remaining",
      value: formatCurrency(vehicle.currentAssignmentTargetRemaining),
      icon: <Target className="h-8 w-8 text-yellow-600" />,
    },
    {
      label: "Current Income",
      value: formatCurrency(vehicle.currentAssignmentIncome),
      icon: <TrendingUp className="h-8 w-8 text-green-500" />,
    },
    {
      label: "Current Distance",
      value: `${vehicle.currentAssignmentDistance.toLocaleString()} km`,
      icon: <BarChart3 className="h-8 w-8 text-blue-600" />,
    },
    {
      label: "Current Expenses",
      value: formatCurrency(vehicle.currentAssignmentExpenses),
      icon: <TrendingDown className="h-8 w-8 text-red-500" />,
    },
    {
      label: "Current Yield",
      value: formatCurrency(vehicle.currentAssignmentYield),
      icon: <BarChart3 className="h-8 w-8 text-indigo-500" />,
    },
    {
      label: "Current Fuel Cost",
      value: formatCurrency(vehicle.currentAssignmentFuelPurchased),
      icon: <Wallet className="h-8 w-8 text-orange-500" />,
    },
    {
      label: "Current Maintenance",
      value: formatCurrency(vehicle.currentAssignmentMaintenanceCost),
      icon: <RefreshCcw className="h-8 w-8 text-purple-500" />,
    },
    {
      label: "Current Incidents",
      value: vehicle.currentAssignmentIncidents,
      icon: <PieChart className="h-8 w-8 text-red-600" />,
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 bg-white rounded-[10px] p-4 gap-4">
      {cards.map(({ label, value, icon }, index) => (
        <DashboardCard
          key={index + label}
          icon={icon}
          value={value}
          label={label}
          width="w-[186px] max-sm:w-full"
        />
      ))}
    </div>
  );
};

export default VehicleFinanceCard02;
